"use strict";

const { initialise_swiper, Swiper } = await import("../initialise-swiper.js"),
	{ Pagination } = await import("../swiper/pagination.js"),
	{ Autoplay } = await import("../swiper/autoplay.js"),
	swiper_containers = document.querySelectorAll(".swiper-product-cards"),
	breakpoint = 1024;
if (swiper_containers.length !== 0) {
	const options = {
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 2,
			},
			1024: {
				slidesPerView: 3,
			},
			1440: {
				slidesPerView: 4,
			},
		},
		loop: true,
		modules: [Autoplay, Pagination],
		pagination: {
			clickable: true,
			el: ".swiper-product-cards-pagination",
			enabled: true,
		},
		watchOverflow: true,
	};
	for (const swiper_container of swiper_containers) {
		if (swiper_container instanceof HTMLElement && swiper_container.dataset.args) {
			const args = JSON.parse(swiper_container.dataset.args);
			if (
				"carousel_toggle" in args &&
				typeof args.carousel_toggle === "boolean" &&
				"carousel_toggle_desktop" in args &&
				typeof args.carousel_toggle_desktop === "boolean"
			) {
				switch (true) {
					case args.carousel_toggle && args.carousel_toggle_desktop:
						new Swiper(swiper_container, options);
						break;
					case args.carousel_toggle && !args.carousel_toggle_desktop:
						initialise_swiper(`(max-width: ${breakpoint}px)`)(() => window.innerWidth < breakpoint)(options)(swiper_container);
						break;
					case !args.carousel_toggle && args.carousel_toggle_desktop:
						initialise_swiper(`(min-width: ${breakpoint}px)`)(() => window.innerWidth >= breakpoint)(options)(swiper_container);
						break;
				}
			}
		}
	}
}
